import { gql } from '@apollo/client';

export const CHANGE_USER_SETTINGS = gql`
  mutation ChangeUserSettings($settings: UserSettingsDto!) {
    changeUserSettings(settings: $settings)
  }
`;

export const DEACTIVATE_ACCOUNT = gql`
  mutation Mutation {
    deactivateUser
  }
`;
export const REMOVE_INTEGRATION = gql`
  mutation RemoveUserIntegration($integration: RemoveIntegrationDto!) {
    removeUserIntegration(integration: $integration)
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation Mutation {
    deleteUser
  }
`;
export const UPDATE_PREFRENCES = gql`
  mutation Mutation($data: UpdateUserPreferencesDto!) {
    updateUserPreferences(data: $data)
  }
`;

export const UPDATE_SERVICES = gql`
  mutation Mutation($services: [String!]!) {
    updateUserServices(services: $services)
  }
`;

export const UPDATE_NOTIFICATIONS = gql`
  mutation Mutation($data: UpdateUserNotificatonSettingsDto!) {
    updateUserNotificationSettings(data: $data)
  }
`;

export const UPDATE_MEETING_BOT_SETTINGS = gql`
  mutation Mutation($data: MeetingBotInputDto!) {
    changeMeetingBotSettings(data: $data)
  }
`;

export const UPDATE_LABEL_SETTINGS = gql`
  mutation Mutation($settings: InboxLabelSettingDto!) {
    changeLabelSettings(settings: $settings)
  }
`;

export const UPDATE_ARCHIVE_SETTINGS = gql`
  mutation SetEmailArchiveLevel($level: String!) {
    setEmailArchiveLevel(level: $level)
  }
`;

export const UPDATE_CALENDAR_LINK = gql`
  mutation SetCalendarLink($calendarLink: String!) {
    setCalendarLink(calendarLink: $calendarLink)
  }
`;

export const UPDATE_PRIMARY_LANGUAGE = gql`
  mutation SetPrimaryLanguage($language: String!) {
    setPrimaryLanguage(language: $language)
  }
`;

export const CANCEL_SCHEDULED_BOT = gql`
  mutation CancelMeetingBot($botId: String!) {
    cancelMeetingBot(botId: $botId)
  }
`;

export const RESCHEDULE_SCHEDULED_BOT = gql`
  mutation ScheduleMeetingBot($meetingId: String!) {
    scheduleMeetingBot(meetingId: $meetingId)
  }
`;

export const SEND_EMAIL = gql`
  mutation SendEmail($data: SendEmailDto!) {
    sendEmail(data: $data)
  }
`;
